export default "__VITE_ASSET__e0nDL3HQ__"